import React from 'react';
import { PictureTalkmont2026 } from '../views';

const AccountGeneralPage = () => {
  return <PictureTalkmont2026 />;
};

export default AccountGeneralPage;
